//@flow
import type { PathT } from "./Types";

export const getPreviousNextStep = (path: PathT, currentStep: string) => {
  const stepIndex = path.findIndex((step) => step.id === currentStep);
  const previousStep = path[stepIndex - 1];
  const nextStep = path[stepIndex + 1];

  return { previousStep, nextStep };
};
